module.exports = __webpack_public_path__ + "img/grandma.ee9abc05.jpg";